import { __require as requireWellKnownSymbol } from './node_modules-core-js-internals-well-known-symbol.js';

var toStringTagSupport;
var hasRequiredToStringTagSupport;

function requireToStringTagSupport () {
	if (hasRequiredToStringTagSupport) return toStringTagSupport;
	hasRequiredToStringTagSupport = 1;
	var wellKnownSymbol = requireWellKnownSymbol();

	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var test = {};

	test[TO_STRING_TAG] = 'z';

	toStringTagSupport = String(test) === '[object z]';
	return toStringTagSupport;
}

export { requireToStringTagSupport as __require };
//# sourceMappingURL=node_modules-core-js-internals-to-string-tag-support.js.map
